import { useEffect, useState, useRef } from "react";

interface UseDebounceOptions {
  delay?: number;
  onChange?: (value: string) => void;
}

export const useDebounce = (value: string, options: UseDebounceOptions = {}) => {
  const { delay = 700, onChange } = options;
  const [debouncedValue, setDebouncedValue] = useState(value);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!value) {
      setDebouncedValue("");
      return;
    }

    timeoutRef.current = setTimeout(() => {
      setDebouncedValue(value);
      onChange?.(value);
    }, delay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [value, delay, onChange]);

  return debouncedValue;
};
